import React from 'react';
import { Box, Typography } from '@mui/material';
import { TldrawBoard } from 'canvas';

/**
 * Legacy export path for premium nested previews and library canvas route.
 * Full board canvas uses TldrawBoard from web/src/canvas/.
 */
const Canvas = props => {
  if (props.canvasData) {
    const name = props.canvasData?.name || 'board';
    return (
      <Box sx={{ p: 1, minWidth: 120 }}>
        <Typography variant="caption">#{name}</Typography>
      </Box>
    );
  }

  if (props.personName && props.hashtag) {
    return (
      <TldrawBoard
        personName={props.personName}
        hashtag={props.hashtag}
        loadedTime={props.loadedTime}
      />
    );
  }

  if (props.personName && props.canvasName) {
    return (
      <TldrawBoard
        personName={props.personName}
        hashtag={props.canvasName}
        loadedTime={props.loadedTime}
      />
    );
  }

  return null;
};

export default Canvas;
